export const ISO_TANKS = [
  {
    id: 'ISO-2401',
    product: 'Methanol (Grade A)',
    lastCleaning: '2026-05-28',
    inspectionDue: '2026-08-15',
    location: 'Jebel Ali Port · Yard B-12',
    utilization: 87,
  },
  {
    id: 'ISO-2402',
    product: 'Base Oil SN150',
    lastCleaning: '2026-04-02',
    inspectionDue: '2026-06-20',
    location: 'Ruwais Refinery · Loading Bay 3',
    utilization: 62,
  },
  {
    id: 'ISO-2403',
    product: 'Empty · Awaiting Clean',
    lastCleaning: '2026-06-01',
    inspectionDue: '2026-09-10',
    location: 'Fujairah Terminal · Clean Bay 2',
    utilization: 0,
  },
  {
    id: 'ISO-2404',
    product: 'Acetic Acid (Hazmat)',
    lastCleaning: '2026-01-15',
    inspectionDue: '2026-06-18',
    location: 'Khalifa Port · ISO Stack 7',
    utilization: 94,
  },
  {
    id: 'ISO-2405',
    product: 'Diesel ULSD',
    lastCleaning: '2026-05-10',
    inspectionDue: '2026-11-22',
    location: 'In Transit · E11 → Musaffah',
    utilization: 78,
  },
  {
    id: 'ISO-2406',
    product: 'Ethylene Glycol',
    lastCleaning: '2026-05-20',
    inspectionDue: '2026-07-05',
    location: 'Jebel Ali Port · Yard A-04',
    utilization: 55,
  },
  {
    id: 'ISO-2407',
    product: 'Jet A-1',
    lastCleaning: '2026-03-18',
    inspectionDue: '2026-06-25',
    location: 'DXB Cargo Village · Gate 9',
    utilization: 91,
  },
  {
    id: 'ISO-2408',
    product: 'Caustic Soda 50%',
    lastCleaning: '2025-12-10',
    inspectionDue: '2026-06-30',
    location: 'Hamriyah Free Zone · Depot 5',
    utilization: 71,
  },
];

export const FLEXI_TANKS = [
  {
    id: 'FLX-8801',
    installDate: '2026-06-08',
    product: 'Palm Olein',
    customer: 'Emirates Food Industries LLC',
    disposal: 'installed',
  },
  {
    id: 'FLX-8802',
    installDate: '2026-06-05',
    product: 'Sunflower Oil',
    customer: 'Gulf Agro Trading FZE',
    disposal: 'in_use',
  },
  {
    id: 'FLX-8803',
    installDate: '2026-05-22',
    product: 'Molasses',
    customer: 'Al Khaleej Sugar Refinery',
    disposal: 'pending_disposal',
  },
  {
    id: 'FLX-8804',
    installDate: '2026-06-10',
    product: 'Liquid Latex',
    customer: 'Dubai Rubber Compounds',
    disposal: 'installed',
  },
  {
    id: 'FLX-8805',
    installDate: '2026-05-30',
    product: 'Wine (Bulk)',
    customer: 'Maritime Beverage Logistics',
    disposal: 'disposed',
  },
  {
    id: 'FLX-8806',
    installDate: '2026-06-02',
    product: 'Glycerine USP',
    customer: 'OGTS Chemical Partners',
    disposal: 'in_use',
  },
];

export const STORAGE_TANKS = [
  {
    id: 'ST-DXB-01',
    capacity: '5,000 MT',
    capacityNum: 5000,
    inventory: 3820,
    product: 'Crude Oil (Murban)',
    health: 'optimal',
  },
  {
    id: 'ST-DXB-02',
    capacity: '2,500 MT',
    capacityNum: 2500,
    inventory: 2100,
    product: 'Gasoil 10ppm',
    health: 'optimal',
  },
  {
    id: 'ST-RUW-01',
    capacity: '10,000 MT',
    capacityNum: 10000,
    inventory: 7450,
    product: 'Naphtha',
    health: 'monitor',
  },
  {
    id: 'ST-RUW-02',
    capacity: '3,200 MT',
    capacityNum: 3200,
    inventory: 890,
    product: 'LPG (Propane Mix)',
    health: 'critical',
  },
  {
    id: 'ST-FJR-01',
    capacity: '4,800 MT',
    capacityNum: 4800,
    inventory: 4200,
    product: 'Fuel Oil 380 CST',
    health: 'optimal',
  },
  {
    id: 'ST-HAM-01',
    capacity: '1,500 MT',
    capacityNum: 1500,
    inventory: 320,
    product: 'Methanol Storage',
    health: 'maintenance',
  },
];

export const DISPOSAL_STATUS = {
  installed: {
    label: 'Installed',
    className: 'bg-logi-accent/100/10 text-blue-700 ring-blue-500/25',
  },
  in_use: {
    label: 'In Use',
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
  },
  pending_disposal: {
    label: 'Pending Disposal',
    className: 'bg-amber-50 text-amber-700 ring-amber-500/25',
  },
  disposed: {
    label: 'Disposed',
    className: 'bg-white text-logi-muted ring-logi-grid',
  },
};

export const TANK_HEALTH = {
  optimal: {
    label: 'Optimal',
    className: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
    barClass: 'bg-emerald-500',
  },
  monitor: {
    label: 'Monitor',
    className: 'bg-amber-50 text-amber-700 ring-amber-500/25',
    barClass: 'bg-amber-500',
  },
  critical: {
    label: 'Critical',
    className: 'bg-red-50 text-red-700 ring-red-500/25',
    barClass: 'bg-red-500',
  },
  maintenance: {
    label: 'Maintenance',
    className: 'bg-logi-accent/10 text-logi-accent ring-violet-500/25',
    barClass: 'bg-violet-500',
  },
};

const REFERENCE_DATE = new Date('2026-06-12');

export function daysSince(dateStr) {
  const d = new Date(dateStr);
  return Math.floor((REFERENCE_DATE - d) / (1000 * 60 * 60 * 24));
}

export function daysUntil(dateStr) {
  const d = new Date(dateStr);
  return Math.floor((d - REFERENCE_DATE) / (1000 * 60 * 60 * 24));
}

export function cleaningUrgency(lastCleaning) {
  const days = daysSince(lastCleaning);
  if (days > 120) return { level: 'critical', label: `${days}d ago · Switch risk`, className: 'text-red-700' };
  if (days > 60) return { level: 'warning', label: `${days}d ago · Review`, className: 'text-amber-700' };
  return { level: 'ok', label: `${days}d ago`, className: 'text-logi-muted' };
}

export function inspectionUrgency(dueDate) {
  const days = daysUntil(dueDate);
  if (days < 0) return { level: 'overdue', label: 'Overdue', className: 'text-red-700 ring-red-500/30 bg-red-50' };
  if (days <= 14) return { level: 'due_soon', label: `${days}d left`, className: 'text-amber-700 ring-amber-500/30 bg-amber-50' };
  return { level: 'ok', label: dueDate, className: 'text-logi-muted' };
}

export function utilizationTone(pct) {
  if (pct >= 90) return 'bg-emerald-500';
  if (pct >= 50) return 'bg-violet-500';
  if (pct > 0) return 'bg-amber-500';
  return 'bg-logi-border';
}

export function computeAssetSummary() {
  const isoCriticalClean = ISO_TANKS.filter((t) => cleaningUrgency(t.lastCleaning).level === 'critical').length;
  const isoInspectionDue = ISO_TANKS.filter((t) => {
    const u = inspectionUrgency(t.inspectionDue);
    return u.level === 'overdue' || u.level === 'due_soon';
  }).length;
  const flexiPending = FLEXI_TANKS.filter((t) => t.disposal === 'pending_disposal').length;
  const storageCritical = STORAGE_TANKS.filter((t) => t.health === 'critical' || t.health === 'maintenance').length;

  return {
    isoCount: ISO_TANKS.length,
    isoCriticalClean,
    isoInspectionDue,
    flexiCount: FLEXI_TANKS.length,
    flexiPending,
    storageCount: STORAGE_TANKS.length,
    storageCritical,
    totalAssets: ISO_TANKS.length + FLEXI_TANKS.length + STORAGE_TANKS.length,
  };
}
